import { useTheme } from '@emotion/react';
import Box from '@mui/material/Box';

var { SunspotLoader, BoltLoader, ScatterBoxLoader } = require('react-awesome-loaders');

export function AnimatedCircleLoader(){
    
    
    return (
        <Box sx={{display:"flex", justifyContent:"center", flexDirection:"column", alignItems:"center", padding:'11em'}}>
            <SunspotLoader
                gradientColors={["#6366F1", "#E0E7FF"]}
                shadowColor={"#3730A3"}
                desktopSize={"128px"}
                mobileSize={"100px"}
            />

        </Box>
    );
}

export function AnimatedBoxLoader() {
    
    
    return (
        <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", padding: '11em' }}>
            <ScatterBoxLoader
                primaryColor={"#6366F1"}
                background={"#3E3F43"}

            />
        </Box>
    );
}
